export const MAX_PRICE_TIERS_PREVIEW = 2;
export const DATE_FORMAT = 'E d MMM yyyy';
export const DATE_FORMAT_SHORT = 'MMM d';

export const MIN_SNAP_POINT_UNAVAILABLE_DATE = '152px';
export const MIN_SNAP_POINT = '136px';
export const MAX_SNAP_POINT = '97%';
export const DEFAULT_SNAP_POINTS = [MIN_SNAP_POINT, MAX_SNAP_POINT];

export const TRIP_CART_PANEL_ROOT = null;
export const TRIP_CART_PANEL_CALENDAR = 'calendar';
export const TRIP_CART_CALENDAR_OLD = 'calendar-old';
export const TRIP_CART_PANEL_TRIP_DETAILS = 'trip-details';
export const TRIP_CART_PANEL_PRICE_DETAILS = 'price-details';

// FORM FIELDS
export const FORM_SELECTED_DATES = 'formSelectedDates';
export const IS_MULTI_DAY = 'isMultiDay';
export const FORM_DURATION = 'formDuration';
export const FORM_GUESTS = 'formGuests';
export const FORM_WITH_CAPTAIN = 'withCaptain';
export const FORM_CAPTAIN_OPTION = 'captainOption';
export const BOOKING_MODE = 'bookingMode';
export const FORM_CAPTAIN_OPTIONS = 'captainOptions';
export const FORM_STATE_VALID = 'isFormStateValid';

// TODO: move this and other trip cart constants to their own location
export const DEFAULT_TRIP_CART_CAPACITY = 2;

// Value of the ID attribute for the review root element on
// the listing page to use it as an anchor to scroll the page to
export const REVIEWS_ROOT_ID = 'reviews';

export const FULL_DAY_HOURS = 24;

export const PERIOD_DAY = 'PERIOD_DAY';
export const PERIOD_NIGHT = 'PERIOD_NIGHT';

export const GALLERY_VIEW = 'gallery';
